/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import sizes from './sizes';

export default function ArchiveIcon({ size = 'xsmall', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
      }}
      width={sizes[size]}
      height={sizes[size]}
      viewBox="0 -1 20 20" // Compensates the original transform="translate(0 1)"
      {...rest}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.96.27a.454.454 0 0 1-.007.385l8.901 4.855a.452.452 0 0 1 .053.034l-.053-.034a.456.456 0 0 1 .184.186l.005.01.009.019.01.025a.451.451 0 0 1 .008.02l-.027-.064c.015.03.027.062.035.094l.006.027.002.015a.451.451 0 0 1 .005.054v8.21a.454.454 0 0 1-.004.042l.004-.057a.457.457 0 0 1-.182.363l-.02.015a.454.454 0 0 1-.038.022l-.011.006-7.273 3.637a.455.455 0 0 1-.476-.77l.07-.043 7.02-3.511V6.644L15.909 7.78v2.675a.91.91 0 0 1-1.812.106l-.006-.106-.001-1.765-2.523 1.262a.455.455 0 0 1-.476-.77l.07-.043 2.34-1.171-8.468-4.435a.905.905 0 0 1-.393-.401L2.347 4.15l8.341 5.005.028.017a.457.457 0 0 1 .107.106l-.016-.02a.456.456 0 0 1 .102.266V17.732a.452.452 0 0 1-.064.228v.001l-.01.014a.457.457 0 0 1-.596.152l-.018-.01-9.091-5.455-.023-.014a.456.456 0 0 1-.04-.03l.063.044a.456.456 0 0 1-.221-.394V4.086a.454.454 0 0 1 .065-.229l.008-.012a.454.454 0 0 1 .038-.051l.002-.003.013-.015a.451.451 0 0 1 .045-.04l.017-.013a.452.452 0 0 1 .01-.008l.013-.008a.454.454 0 0 1 .046-.026l.013-.005L4.858 2.04a.912.912 0 0 1 .485-.216L8.193.557A.453.453 0 0 1 8.78.023l.075.033.211.114.296-.13a.455.455 0 0 1 .6.23zM1.819 4.893v7.123l8.181 4.908V9.802l-8.181-4.91zm13.66 2.061l.021.015 2.155-1.078-8.63-4.707-2.466 1.095 8.864 4.643.057.032z"
      />
    </svg>
  );
}
